import request from '@/utils/request';

// 登陆
export function api_login(params) {
  return request.post('/bussbank/oauth/token', params);
}

// 获取用户信息
export function api_getUserInfo(params) {
  return request({
    url: '/bussbank/oauth/user',
    method: 'get',
    params: params
  });
}

// 获取企业列表
export function api_getEnterpriseList(params) {
  return request({
    url: '/bussscreen/bankStatistics/listAuthEnterprise',
    method: 'get',
    params: params
  });
}
